<template>
    <div class="bg-white py-16 sm:py-24">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="mx-auto max-w-2xl lg:text-center">
                <h2 class="text-base/7 font-semibold tracking-wide text-primary-700 uppercase">Why us</h2>
                <p
                    class="font-display mt-2 text-pretty text-2xl text-ink-900 sm:text-3xl lg:text-balance">
                    Best Arabic & The Quran Learning Experince
                </p>
            </div>
            <div class="mx-auto mt-8 max-w-2xl sm:mt-16 lg:mt-20 lg:max-w-4xl">
                <dl class="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-3 lg:gap-y-16">
                    <div v-for="feature in features" :key="feature.name" class="relative">
                        <dt class="text-base/7 font-semibold text-ink-900 text-center">
                            <div class="flex items-center justify-center rounded-full bg-primary-50 ring-1 ring-primary-100 size-16 mx-auto">
                                <img v-if="feature.icon" :src="feature.icon" alt="" class="size-8" />
                            </div>
                            <div class="mt-6">
                                <span>
                                    {{ feature.name }}
                                </span>
                            </div>
                        </dt>
                        <dd class="mt-2 text-base/7 text-ink-600 text-center">{{ feature.description }}</dd>
                    </div>
                </dl>
            </div>
        </div>
    </div>
</template>

<script setup>
import {
    ChatBubbleLeftEllipsisIcon,
    CalendarIcon,
    CursorArrowRaysIcon,
    CubeIcon,
    GlobeAltIcon,
    ArrowPathIcon, CloudArrowUpIcon, FingerPrintIcon, LockClosedIcon } from '@heroicons/vue/24/outline'

const features = [
    {
        name: 'Native Arabic Tutors',
        description: 'Our tutors are native Arabic speakers, ensuring an authentic learning experience.',
        icon: 'images/icons/features/arabic.png',
    },
    {
        name: 'Flexible Scheduling',
        description: 'Choose your own schedule and learn at your own pace.',
        icon: 'images/icons/features/calendar.png',
    },
    {
        name: 'Interactive Learning',
        description: 'Engaging lessons with interactive tools and resources.',
        icon: 'images/icons/features/chat.png',
    },
    {
        name: 'Certified Tutors',
        description: 'Al-Azhar certified professional teachers are available.',
        icon: 'images/icons/features/certified.png',
    },
    {
        name: 'Comprehensive Curriculum',
        description: 'A well-structured curriculum covering all aspects of Arabic and Quranic studies.',
        icon: 'images/icons/features/zip.png',
    },
    {
        name: '24/7 Support',
        description: 'Our support team is available around the clock to assist you.',
        icon: 'images/icons/features/support.png',
    },
]
</script>
